import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Pipe({
    name: 'customSplit'
})
export class CustomSplitPipe implements PipeTransform {

    constructor(public app: AppService) {}


    transform(sent: string): string {
        if (!sent) {
            return sent;
        }

        if (sent.includes("-\t")) {
            return this.splitAndReturn(sent, "-\t");
        } else if (sent.includes("\n")) {
            return this.splitAndReturn(sent, "\n\n");
        } else {
            return sent;
        }
    }

    private splitAndReturn(sent: string, delimiter: string): string {
        const parts = sent.split(delimiter);
        const firstPart = parts[0];

        if (this?.app?.languageCode === 'ar') {
            return this.isProbablyArabic(firstPart) ? parts[0] : parts[1];
        } else if (this.app?.languageCode === 'en') {
            return this.isProbablyArabic(firstPart) ? parts[1] : parts[0];
        }

        return sent;
    }


    isProbablyArabic(str: string): boolean {
        var Character
        for (var i = 0; i < str.length; i++) {
            let c = str.codePointAt(i);
            if (c >= 0x0600 && c <= 0x06E0)
                return true;
        }
        return false;
    }

}

// splitStringToArAndEnForAbout(sent: string): string {
//     if (!sent) { return }
//     if (isPlatformBrowser(this.platformId)) {
//       if (sent.includes("-\t")) {
//         let x = sent?.split("-\t")
//         let y = x[0]
//         if (this?.app?.languageCode == 'ar') {
//           if (this.isProbablyArabic(y)) {
//             return x[0]
//           } else {
//             return x[1]
//           }
//         } else if (this?.app?.languageCode == 'en') {
//           if (this.isProbablyArabic(y)) {
//             return x[1]
//           } else {
//             return x[0]
//           }
//         }
//       } else if (sent.includes("\n")) {
//         let x = sent?.split("\n\n")
//         let y = x[0]
//         if (this?.app?.languageCode == 'ar') {
//           if (this.isProbablyArabic(y)) {
//             return x[0]
//           } else {
//             return x[1]
//           }
//         } else if (this?.app?.languageCode == 'en') {
//           if (this.isProbablyArabic(y)) {
//             return x[1]
//           } else {
//             return x[0]
//           }
//         }
//       } else {
//         return sent
//       }
//     } else {
//       return sent
//     }
//   }
